import "./App.css";
//import { ExportToExcel } from "./components/ExportToExcel";
import { Home } from "./components/Home";

function App() {
  return (
    <div className="app_container">
      <Home/>
    </div>
  );
}

export default App;
